import { Helmet } from "react-helmet-async";
import { Container, Grid } from "@mui/material";
import DishTable from "./dishlisting";



function DishList() {
    return (
      <>
        <Helmet>
          <title>Categories</title>
        </Helmet>

        <Container maxWidth="lg">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={3}
          >
            <Grid item xs={12}>
              <DishTable />
            </Grid>
          </Grid>
        </Container>
      </>
    );
  }
  
  export default DishList;